import { Facade } from './facade';

export const Views = {
    Facade
};